<div class="modal show"
	tabindex="-1">
	<div class="modal-dialog modal-lg modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-body d-flex flex-column">
				<div class="d-flex justify-content-end mb-auto btn-close-holder">
					<button (click)="cancel()"
						type="button"
						class="btn-close"></button>
				</div>
				<div class="d-flex flex-column mb-auto">
					<div *ngIf="data.header"
						class="dialog-header">
						{{ data.header }}
					</div>
					<div *ngIf="data.type && data.type === 'warning'"
						class="text-center mb-4">
						<img src="assets/images/icon-confirmation-warning.png"
							width="72px"
							height="auto">
					</div>
					<div class="dialog-text-block">
						<div *ngIf="data.title"
							[ngClass]="{ 'text-center' : !data.header}"
							class="dialog-title fs-4 mb-5">
							{{data.title}}
						</div>
						<div *ngIf="data.detail"
							class="text-center dialog-detail mb-5">
							{{data.detail}}
						</div>
					</div>
					<div class="d-flex justify-content-center dialog-buttons">
						<button *ngIf="data.cancelButtonText"
							(click)="cancel()"
							class="btn-styled--secondary me-4">
							{{data.cancelButtonText}}
						</button>
						<button (click)="confirm()"
							class="btn-styled">
							<span *ngIf="data.buttonText">{{data.buttonText}}</span>
							<span *ngIf="!data.buttonText">OK</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-backdrop fade show modal-slide-show"></div>
